export const en = {
    "admin-settings": "Administrative settings",
    "alert-unsave-message": "You have unsaved changes, do you really want to continue?",
    "description-delete-language-one": "The description for the language will be permanently deleted.",
    "description-delete-language-two": "Also, all related countries will be unavailable for publication.",
    "devices-add": "Add device",
    "devices-add-market": "Add device card IDs from Yandex Market[], or enter the device name and select from the drop-down list. The specified devices will be displayed on Yandex.Market with Alice's badge [].",
    "devices-added-devices": "Registered devices",
    "devices-added-earlier": "Added earlier",
    "devices-empty-list": "No registered devices",
    "devices-error-default": "Loading error. Check your internet connection.",
    "devices-error-duplicate": "This device is already registered.",
    "devices-error-invalid": "Invalid ID.",
    "devices-error-not_found": "No device with this ID was found.",
    "devices-label": "ID or product name",
    "devices-new-devices": "New devices",
    "devices-supported": "Supported devices",
    "dialog-banned": "Dialog banned.",
    "draft": "Draft",
    "feature-flags": "Feature Flags",
    "header-delete-language": "Delete language?",
    "icon": "icon",
    "icon-click-to-load": "Click to download",
    "icon-is-loading": "Loading...",
    "loading": "loading",
    "menu-access": "Access",
    "menu-account-link": "Account linking",
    "menu-donation": "Donations",
    "menu-editors": "Editors fields",
    "menu-general": "General",
    "menu-monitoring": "Monitoring",
    "menu-notifications": "Notifications",
    "menu-pay": "Payment",
    "menu-promo": "Promotion",
    "menu-rating": "User ratings",
    "menu-resources": "Resources",
    "menu-settings": "Settings",
    "menu-test": "Testing",
    "no-published": "You have not published any version of the dialog yet",
    "published": "Published",
    "settings": "Settings",
    "submenu-agreements": "User agreements",
    "submenu-devices": "Devices",
    "submenu-intents": "Intents",
    "submenu-main": "Main settings",
    "ua-add": "Add",
    "ua-error-unknown": "Unknown error",
    "ua-name": "Title",
    "ua-save": "Save",
    "ua-url": "URL",
    "ua-validity-name-long": "Title too long",
    "ua-validity-name-req": "Title required",
    "ua-validity-name-uniq": "Title should be unique",
    "ua-validity-url-incorrect": "URL invalid",
    "ua-validity-url-long": "URL too long",
    "ua-validity-url-req": "URL required",
    "ua-validity-url-uniq": "URL should be unique",
    "upload-choose-file": "Choose file",
    "upload-choose-other": "Choose another file",
    "upload-apk-error-format": "Only .apk files allowed",
    "upload-error-format": "Available extensions: png, jpeg",
    "upload-error-max-size": "File size should not exceed 3 MB",
    "user-agreements-url": "URL",
    "no-user-agreements": "No user agreements",
    "devices-from-market": 'Add the device card IDs from Yandex.Market [], or enter the device name and select it from the dropdown. Devices will be visible in the "Home with Alice" app.',
    "events": "Events",
} as const;
export const ru = {
    "admin-settings": "Административные настройки",
    "alert-unsave-message": "У вас есть несохраненные изменения, вы действительно хотите продолжить?",
    "description-delete-language-one": "Описание для языка будет удалено без возможности восстановления.",
    "description-delete-language-two": "Также, все связанные страны будут недоступны для публикации.",
    "devices-add": "Добавить устройство",
    "devices-add-market": "Добавьте ID карточек устройств из Яндекс Маркета [], либо введите название устройства и выберите из выпадающего списка. Указанные устройства будут отображаться на Яндекс Маркете с бейджем Алисы [].",
    "devices-added-devices": "Добавленные устройства",
    "devices-added-earlier": "Добавленные ранее",
    "devices-empty-list": "Нет добавленных устройств",
    "devices-error-default": "Ошибка загрузки. Проверьте подключение к интернету.",
    "devices-error-duplicate": "Такое устройство уже добавлено.",
    "devices-error-invalid": "Введен неверный ID.",
    "devices-error-not_found": "Устройство с таким ID не найдено.",
    "devices-label": "ID или название товара",
    "devices-new-devices": "Новые устройства",
    "devices-supported": "Поддерживаемые устройства",
    "dialog-banned": "Диалог забанен.",
    "draft": "Черновик",
    "feature-flags": "Флаги",
    "header-delete-language": "Удалить язык?",
    "icon": "иконка",
    "icon-click-to-load": "Нажмите, чтобы загрузить",
    "icon-is-loading": "Идёт загрузка...",
    "loading": "загрузка",
    "menu-access": "Доступ",
    "menu-account-link": "Связка аккаунтов",
    "menu-donation": "Донаты",
    "menu-editors": "Редакторские поля",
    "menu-general": "Общие сведения",
    "menu-monitoring": "Мониторинг",
    "menu-notifications": "Уведомления",
    "menu-pay": "Оплата",
    "menu-promo": "Продвижение",
    "menu-rating": "Оценки пользователей",
    "menu-resources": "Ресурсы",
    "menu-settings": "Настройки",
    "menu-test": "Тестирование",
    "no-published": "Вы еще не опубликовали ни одной версии диалога",
    "published": "Опубликованная версия",
    "settings": "Настройки",
    "submenu-agreements": "Пользовательские соглашения",
    "submenu-devices": "Устройства",
    "submenu-intents": "Интенты",
    "submenu-main": "Главные настройки",
    "ua-add": "Добавить",
    "ua-error-unknown": "Неизвестная ошибка",
    "ua-name": "Название",
    "ua-save": "Сохранить",
    "ua-url": "Url-адрес соглашения",
    "ua-validity-name-long": "Название слишком длинное",
    "ua-validity-name-req": "Название обязательно",
    "ua-validity-name-uniq": "Название должно быть уникально",
    "ua-validity-url-incorrect": "Введён некорректный URL",
    "ua-validity-url-long": "URL адрес слишком длинный",
    "ua-validity-url-req": "URL обязателен",
    "ua-validity-url-uniq": "URL должен быть уникален",
    "upload-choose-file": "Выбрать файл",
    "upload-choose-other": "Выбрать другой файл",
    "upload-apk-error-format": "Допустимый формат .apk",
    "upload-error-format": "Допустимые форматы: png и jpeg",
    "upload-error-max-size": "Размер файла не должен превышать 3 МБ",
    "user-agreements-url": "URL-адрес соглашения",
    "no-user-agreements": "Нет соглашений",
    "devices-from-market": "Добавьте ID карточек устройств из Яндекс.Маркета [], либо введите название устройства и выберите его из выпадающего списка.\nУстройства будут видны в приложении «Дом с Алисой»",
    "events": "События",
} as const;
